module.exports = __webpack_public_path__ + "img/about-us-fetures.3fcf7e32.jpg";